"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getSupportedThemes = _interopRequireDefault(require("./getSupportedThemes"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = function _default(brandingId, themeName) {
  if (brandingId === 12) {
    return false;
  }

  // no theme name means the UI will use the default theme
  // for the brandingId which means it's guaranteed to be
  // supported
  if (!themeName) {
    return true;
  }
  var supported = (0, _getSupportedThemes.default)(brandingId);
  return supported.includes(themeName);
};